<ion-content>
    <ion-buttons class="ion-float-right">
      <ion-button (click)="onCancel()">
        <ion-icon name="close" mode="md"></ion-icon>
      </ion-button>
    </ion-buttons>
  <app-phone-form [bookingDialog]="true"></app-phone-form>
</ion-content>